/* @ngInject */
function CampaignMaterialActionsController ($rootScope, $timeout, $scope, $translate, $window, $state, TemplateService, AssetPreviewService, ConfirmationModalService, CampaignActionService, ToastService, Utils) {
  $scope.lastUrl = $window.location.href
  $scope.flags = {
    advancedOptions: false,
    isContentRequired: false,
    publicationDate: false,
    expirationDate: false,
    isFormValid: false,
    loading: false,
    hasUnsavedChanges: false,
    buttonLoading: false,
    descriptionError: false,
    disableDates: false
  }

  $scope.chevron = 'chevron-down'
  $scope.materials = []

  $scope.formData = {
    description: '',
    publicationDate: null,
    expirationDate: null
  }

  let defaultDescription = ''

  const api = {
    _isFormValid,
    _successSaveAction,
    _setFormData,
    _setDates,
    _archiveAction,
    _unpublishAction
  }

  this.getApi = () => api

  activate()

  function activate () {
    defaultDescription = $translate.instant('campaignsModule.campaignsMaterialActions.descriptionPlaceholder')
    $scope.flags.hasUnsavedChanges = false
    $scope.flags.isFormValid = false
  }

  const deregisterActionIdWatcher = $scope.$watch('action.id', (newId) => {
    const numberRegex = /^\d+$/

    if (numberRegex.test(newId)) {
      CampaignActionService.getCampaignActionDetails($scope.campaign.id, $scope.action.id).then(api._setFormData)
    } else {
      const action = {
        ...$scope.action,
        campaignId: $scope.campaign.id,
        description: defaultDescription
      }

      api._setFormData(action)
      $scope.action = action
      $scope.flags.hasUnsavedChanges = true
      api._isFormValid()
      api._setDates()
    }
  })

  const deregisterMaterialsLengthWatcher = $scope.$watch('materials.length', (newLength) => {
    if (newLength > 0) {
      $scope.flags.isFormValid = true
      $scope.flags.hasUnsavedChanges = true
    } else {
      $scope.flags.isFormValid = false
      $scope.flags.hasUnsavedChanges = false
    }
  })

  function _setFormData (action) {
    $scope.formData = {
      description: action.description,
      artIds: action.artIds,
      isContentRequired: action.isContentRequired,
      publicationDate: action.publicationDate || null,
      expirationDate: action.expirationDate || null
    }

    $scope.flags.isContentRequired = action.isContentRequired
    $scope.flags.publicationDate = action.publicationDate
    $scope.flags.expirationDate = action.expirationDate
    $scope.flags.advancedOptions = action.isContentRequired || action.publicationDate || action.expirationDate
    $scope.flags.hasUnsavedChanges = false

    if (action?.arts?.length) {
      $scope.materials.push(...action.arts)
    }

    if (action?.artCollections?.length) {
      $scope.materials.push(...action.artCollections)
    }

    api._isFormValid()
  }

  $scope.clickAttachMaterials = () => {
    if ($scope.materials.length) return
    $rootScope.$emit('campaign.change-tab-action', 'tab-3')
    /**
     * Emitido com timeout para dar tempo da tab carregar (caso não tenha sido pré-ativada antes).
     */
    $timeout(() => {
      $rootScope.$emit('campaign.select-material-floating-tool-bar', {
        materials: $scope.materials ? [...$scope.materials] : [],
        action: $scope.action
      })
    }, 100)
  }

  const deregisterAttachMaterialActions = $rootScope.$on('campaign.attach-material-actions', (event, selectedMaterials) => {
    $scope.materials = selectedMaterials ? [...selectedMaterials] : []

    $scope.flags.hasUnsavedChanges = true
    api._isFormValid()
    api._setDates()

    if ($scope.materials.length) {
      ToastService.showSuccessToast($translate.instant('campaignEdit.actions.assetAttachedToast'))
    }
  })

  const beforeUnloadHandler = (event) => {
    if ($scope.flags.hasUnsavedChanges) {
      event.preventDefault()
      event.returnValue = $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.content')
    }
  }

  $window.addEventListener('beforeunload', beforeUnloadHandler)

  $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
    if ($scope.flags.hasUnsavedChanges && toState.name !== fromState.name) {
      event.preventDefault()

      $scope.handleCancel(true, () => {
        $scope.lastUrl = toState.url
        $state.go(toState, toParams)
      })
    }
  })

  $scope.handleCancel = (shouldShowDialog, onConfirm) => {
    if (!shouldShowDialog) {
      if (typeof onConfirm === 'function') onConfirm()
      return
    }

    ConfirmationModalService.createModal({
      title: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.title'),
      description: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.content'),
      buttonCancelText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.buttons.close'),
      buttonConfirmText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.closeWithoutSaving.buttons.confirm'),
      onConfirm: () => {
        $scope.flags.hasUnsavedChanges = false
        if (typeof onConfirm === 'function') onConfirm()
      }
    })
  }

  $scope.$on('$destroy', () => {
    deregisterAttachMaterialActions()
    deregisterActionIdWatcher()
    deregisterMaterialsLengthWatcher()
    $window.removeEventListener('beforeunload', beforeUnloadHandler)
  })

  $scope.handleArchiveButtonClick = () => {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.title'),
      description: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.content'),
      buttonCancelText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.buttons.close'),
      buttonConfirmText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.archiveAction.buttons.confirm'),
      onConfirm: () => api._archiveAction()
    })
  }

  function _isFormValid () {
    $scope.flags.isFormValid = $scope.flags.hasUnsavedChanges && $scope.materials.length > 0
  }

  $scope.onChangeMaterialActionDescription = (event) => {
    const newValue = event.detail.value
    $scope.formData.description = newValue
    $scope.flags.hasUnsavedChanges = $scope.formData.description !== $scope.action?.description
    api._isFormValid()
  }

  $scope.onChangePublicationDate = (event) => {
    const newDate = event.detail.date
    $scope.formData.publicationDate = newDate
    $scope.flags.hasUnsavedChanges = newDate !== $scope.action?.publicationDate
    api._isFormValid()
  }

  $scope.onChangeExpirationDate = (event) => {
    const newDate = event.detail.date
    $scope.formData.expirationDate = newDate
    $scope.flags.hasUnsavedChanges = newDate !== $scope.action?.expirationDate
    api._isFormValid()
  }

  $scope.clickAdvancedOptions = () => {
    $scope.flags.advancedOptions = !$scope.flags.advancedOptions
    $scope.chevron = $scope.flags.advancedOptions ? 'chevron-up' : 'chevron-down'
  }

  $scope.isContentRequired = (event) => {
    const newValue = event.detail.value
    $scope.flags.isContentRequired = newValue
    $scope.flags.hasUnsavedChanges = newValue !== $scope.action?.isContentRequired
    api._isFormValid()
  }

  $scope.publicationDate = (event) => {
    const newValue = event.detail.value
    $scope.flags.publicationDate = newValue
    if ($scope.formData.publicationDate) {
      $scope.formData.publicationDate = undefined
      $scope.flags.hasUnsavedChanges = true
      api._isFormValid()
    }
  }

  $scope.isContentRequired = (event) => {
    $scope.flags.isContentRequired = event.detail.value
    $scope.flags.hasUnsavedChanges = true
    api._isFormValid()
  }

  $scope.expirationDate = (event) => {
    const newValue = event.detail.value
    $scope.flags.expirationDate = newValue
    if ($scope.formData.expirationDate) {
      $scope.formData.expirationDate = undefined
      $scope.flags.hasUnsavedChanges = true
      api._isFormValid()
    }
  }

  $scope.handleConfirmButtonClick = () => {
    if (!$scope.formData.description) {
      $scope.flags.descriptionError = true
      return
    }

    if (!$scope.flags.isFormValid) return

    const templates = $scope.materials.filter(material => 'isTemplate' in material)
    const folders = $scope.materials.filter(material => !('isTemplate' in material))

    const action = {
      description: $scope.formData.description,
      artIds: templates.map(template => template.id),
      artCollectionIds: folders.map(folder => folder.id),
      isContentRequired: $scope.flags.isContentRequired,
      type: 'ART'
    }

    action.publicationDate = $scope.formData.publicationDate || undefined
    action.expirationDate = $scope.formData.expirationDate || undefined

    $scope.flags.buttonLoading = true

    const numberRegex = /^\d+$/
    if (numberRegex.test($scope.action.id)) {
      CampaignActionService.sanitizeAction($scope.action)
      CampaignActionService.updateCampaignAction($scope.campaign.id, $scope.action.id, action)
        .then(api._successSaveAction)
        .catch(CampaignActionService.handleSaveActionError)
        .finally(() => { $scope.flags.buttonLoading = false })
    } else {
      CampaignActionService.createCampaignAction($scope.campaign.id, action)
        .then(newAction => api._successSaveAction(newAction, true))
        .catch(CampaignActionService.handleSaveActionError)
        .finally(() => { $scope.flags.buttonLoading = false })
    }
  }

  $scope.getVisibilityLabel = () => {
    return CampaignActionService.getVisibilityLabel($scope.action)
  }

  $scope.shouldShowArchiveButton = () => {
    const numberRegex = /^\d+$/
    return numberRegex.test($scope.action.id)
  }

  $scope.handleUnpublishButtonClick = () => {
    ConfirmationModalService.createModal({
      title: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.title'),
      description: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.content'),
      buttonCancelText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.buttons.close'),
      buttonConfirmText: $translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.buttons.confirm'),
      onConfirm: () => api._unpublishAction()
    })
  }

  function _successSaveAction (newAction, isNewAction) {
    $scope.flags.hasUnsavedChanges = false
    $scope.flags.isFormValid = false
    ToastService.showSuccessToast($translate.instant('saved'))
    $scope.$emit('campaign.reload-actions', newAction.id)

    if (isNewAction) {
      CampaignActionService.sendCreateCampaignActionEvent($scope.campaign, newAction)
    }
  }

  function _setDates () {
    const scheduleDate = CampaignActionService.findScheduleDateInMaterials($scope.materials)

    if (scheduleDate) {
      $scope.formData.publicationDate = scheduleDate
      $scope.formData.expirationDate = $scope.campaign.deliveryDate
      $scope.flags.disableDates = true
      $scope.flags.advancedOptions = true
      $scope.flags.publicationDate = true
      $scope.flags.expirationDate = true
    } else {
      $scope.flags.disableDates = false
    }
  }

  function _archiveAction () {
    CampaignActionService.archiveCampaignAction($scope.campaign.id, $scope.action.id)
      .then(() => {
        $scope.flags.hasUnsavedChanges = false
        ToastService.showSuccessToast($translate.instant('campaignEdit.actions.archiveSuccess'))
        $(`.campaign-actions-list-content .campaign-action-item-${$scope.action.id}`).click()
        $scope.$emit('campaign.reload-actions', $scope.action.id)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  function _unpublishAction () {
    $scope.flags.buttonLoading = true
    CampaignActionService.unpublishCampaignAction($scope.campaign.id, $scope.action.id)
      .then(() => {
        ToastService.showSuccessToast($translate.instant('campaignsModule.campaignActionsGeneralDialog.unpublishActions.successMessage'))
        $scope.$emit('campaign.reload-actions', $scope.action.id)
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
      .finally(() => {
        $scope.flags.buttonLoading = false
      })
  }
}

export { CampaignMaterialActionsController }
